import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { CloseOutlined, PlusCircleOutlined, HistoryOutlined, AppstoreOutlined, DashboardOutlined } from '@ant-design/icons';

interface SidebarProps {
  onClose?: () => void;
}

const Sidebar = ({ onClose }: SidebarProps) => {
  const location = useLocation();

  const isActive = (path: string) => {
    return location.pathname === path 
      ? 'bg-white/10 text-white font-medium' 
      : 'text-slate-200 hover:bg-white/5 hover:text-white';
  };

  return (
    <div className="h-full w-[280px] lg:w-72 bg-gradient-to-b from-cyan-900 to-cyan-800">
      <div className="flex justify-between items-center p-6 border-b border-white/10 lg:hidden">
        <h2 className="text-white font-semibold text-lg">Navigation</h2>
        {onClose && (
          <button
            onClick={onClose}
            className="p-2 hover:bg-white/5 rounded-lg text-slate-200 hover:text-white transition-colors"
          >
            <CloseOutlined className="text-lg" />
          </button>
        )}
      </div>
      
      <div className="px-4 py-6">
        <nav className="space-y-1">
          <Link 
            to="/dashboard" 
            className={`${isActive('/dashboard')} group flex items-center px-4 py-3 text-sm rounded-lg transition-colors duration-150`}
            onClick={() => onClose?.()}
          >
            <DashboardOutlined className="text-lg mr-3" />
            <span>Dashboard</span>
          </Link>
          <Link 
            to="/new-echo" 
            className={`${isActive('/new-echo')} group flex items-center px-4 py-3 text-sm rounded-lg transition-colors duration-150`}
            onClick={() => onClose?.()}
          >
            <PlusCircleOutlined className="text-lg mr-3" />
            <span>New Echo</span>
          </Link>
          <Link 
            to="/previous-echos" 
            className={`${isActive('/previous-echos')} group flex items-center px-4 py-3 text-sm rounded-lg transition-colors duration-150`}
            onClick={() => onClose?.()}
          >
            <HistoryOutlined className="text-lg mr-3" />
            <span>Previous Echos</span>
          </Link>
          <Link 
            to="/products" 
            className={`${isActive('/products')} group flex items-center px-4 py-3 text-sm rounded-lg transition-colors duration-150`}
            onClick={() => onClose?.()}
          >
            <AppstoreOutlined className="text-lg mr-3" />
            <span>Products</span>
          </Link>
        </nav>
      </div>
    </div>
  );
};

export default Sidebar; 